import { useGateValue } from '@statsig/react-bindings';

export const ROUTE_DEVIATION_GATE = 'route_deviation_setup';

/**
 * Local development has no Statsig key, so every gate is closed. A developer
 * lists gate names in REACT_APP_FORCE_GATES to open them. Only a Vite dev
 * server on the `development` tier honours it, so a deployed build can never
 * force a gate. The tier default matches StatsigAppProvider.
 */
const isForcedOn = (gate: string): boolean => {
  if (!import.meta.env.DEV) return false;
  const tier = process.env.REACT_APP_STATSIG_TIER || 'development';
  if (tier !== 'development') return false;
  return (process.env.REACT_APP_FORCE_GATES ?? '')
    .split(',')
    .some((name) => name.trim() === gate);
};

export function useRouteDeviationGate(): boolean {
  const gateOpen = useGateValue(ROUTE_DEVIATION_GATE);
  return gateOpen || isForcedOn(ROUTE_DEVIATION_GATE);
}
